<template>
  <v-row>
    <v-col>
      <div class="text-h5 font-weight-bold">{{ title }}</div>
      <v-data-iterator
        :no-data-text="noDataText"
        :items="dadosTabela"
        :items-per-page.sync="itemsPerPage"
        :page="pagePorDia"
        :search="searchTabelaDia"
        :no-results-text="noResultsText"
        hide-default-footer
      >
        <template v-slot:header>
          <v-row justify="end">
            <v-col cols="4">
              <v-text-field
                v-model="searchTabelaDia"
                clearable
                hide-details
                prepend-inner-icon="mdi-magnify"
                label="Busca"
              />
            </v-col>
          </v-row>
        </template>
        <template v-slot:default="props">
          <v-data-table
            dense
            :headers="headersDia"
            :items="props.items"
            hide-default-footer
            class="elevation-1"
            disable-pagination
            disable-sort
          />
        </template>

        <template v-slot:footer>
          <v-row class="mt-2" align="center" justify="center">
            <div class="ml-4 mb-2 grey--text">
              <p>Total de Registros: {{ dadosTabela.length }}</p>
            </div>
            <v-spacer />
            <div class="pb-5">
              <ListPagination
                :page="pagePorDia"
                :numberOfPages="numberOfPagesDia"
                @firstPage="firstPage()"
                @formerPage="formerPage()"
                @nextPage="nextPage()"
                @lastPage="lastPage()"
              />
            </div>
          </v-row>
        </template>
      </v-data-iterator>
    </v-col>
  </v-row>
</template>

<script>
import ListPagination from '@/componentes/ListPagination'

export default {
  name: 'TableDataPorDia',
  components: { ListPagination },
  props: ['dadosTabela', 'title'],
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    searchTabelaDia: '',
    pagePorDia: 1,
    itemsPerPage: 20,
    headersDia: [
      { text: 'Dia', value: 'data', align: 'left' },
      { text: 'Total', value: 'total', align: 'right' },
      { text: 'Atendidas', value: 'atendidas', align: 'left' },
      { text: 'Não Atendidas', value: 'naoAtendidas', align: 'left' },
      { text: 'TMC', value: 'tmc', align: 'left' },
      { text: 'TMA', value: 'tma', align: 'left' },
      { text: 'TME', value: 'tme', align: 'left' },
    ],
    itemsDia: [],
  }),

  computed: {
    qtdRegistrosDia() {
      return this.itemsDia.length
    },
    numberOfPagesDia() {
      return Math.ceil(this.dadosTabela.length / this.itemsPerPage)
    },
  },

  methods: {
    nextPage() {
      if (this.pagePorDia + 1 <= this.numberOfPagesDia) {
        this.pagePorDia += 1
      }
    },
    formerPage() {
      if (this.pagePorDia - 1 >= 1) {
        this.pagePorDia -= 1
      }
    },
    firstPage() {
      if (this.pagePorDia > 1) {
        this.pagePorDia = 1
      }
    },
    lastPage() {
      if (this.pagePorDia < this.numberOfPagesDia) {
        this.pagePorDia = this.numberOfPagesDia
      }
    },
  },
}
</script>
